import * as THREE from 'three';

/**
 * @param {THREE.BufferGeometry} geometry
 * @param {number} textureScale 
 * @returns {THREE.BufferGeometry} 
 */
export function applyWorldUVs(geometry, textureScale = 0.3) {
    // Преобразуем геометрию в non-indexed, чтобы угловые вершины не усредняли нормали
    if (geometry.index) {
        geometry = geometry.toNonIndexed();
    }

    geometry.computeBoundingBox();
    geometry.computeVertexNormals();
    const normals = geometry.attributes.normal;

    const pos = geometry.attributes.position;
    const count = pos.count;
    const uvs = new Float32Array(count * 2);

    for (let i = 0; i < count; i++) {

        const x = pos.getX(i);
        const y = pos.getY(i);
        const z = pos.getZ(i);

        const nx = Math.abs(normals.getX(i));
        const ny = Math.abs(normals.getY(i));
        const nz = Math.abs(normals.getZ(i));

        let u = 0;
        let v = 0;


        if (nz > nx && nz > ny) {

            u = x;
            v = y;
        } else if (nx > ny && nx > nz) {
            u = y;
            v = z;
        } else {
            u = x;
            v = z;
        }

        uvs[i * 2] = u / textureScale;
        uvs[i * 2 + 1] = v / textureScale;
    }

    geometry.setAttribute('uv', new THREE.BufferAttribute(uvs, 2));
    geometry.attributes.uv.needsUpdate = true;

    return geometry;
}
